import { render } from "./detalhe.vue?vue&type=template&id=afdce69c&scoped=true"
import script from "./detalhe.vue?vue&type=script&lang=js"
export * from "./detalhe.vue?vue&type=script&lang=js"

import "./detalhe.vue?vue&type=style&index=0&id=afdce69c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afdce69c"]])

export default __exports__